import {useQuery, type UseQueryOptions} from 'react-query';
import {fetchBanners, type FetchBannersResponse} from '../../http/banners/fetchBanners';

export const bannersQueryKey = ['banners'] as const;

export function useFetchBanners(options?: UseQueryOptions<FetchBannersResponse>) {
	return useQuery<FetchBannersResponse>({
		queryKey: bannersQueryKey,
		queryFn: async ({signal}) => {
			const {data} = await fetchBanners(signal);

			return data;
		},
		...options,
	});
}
